import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      margin: 0,
      "& div": {
        height: "100%",
      },
    },
    textField: {
      minWidth: "150px",
      width: "100%",
      "& input": {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        direction: "rtl",
        textAlign: "left",
        "&:focus": {
          direction: "ltr",
        },
      },
      "& > .MuiInputLabel-root": {
        color: "rgba(0, 0, 0, 0.6)",
      },
    },
    validField: {
      "& > .MuiInputLabel-root": {
        color: theme.additionalColors.ampelGruen,
      },
      "& fieldset": {
        borderColor: `${theme.additionalColors.ampelGruen}!important`,
      },
    },
    endAdornment: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
      alignItems: "end",
    },
    popupIndicator: {
      color: "black",
      height: "32px",
      width: "32px",
      marginRight: "6px",
      "&:hover": {
        background: "none",
      },
      "& span": {
        "& svg": {
          fontSize: "2rem",
        },
      },
    },
    clearIndicator: {
      position: "absolute",
      right: "30px",
    },
  })
);

export default useStyles;
